<template>
  <div class="blog-wrapper">
    <div class="header font">
      <div class="pad-cover" style="background-image: url('https://uploads.strikinglycdn.com/static/backgrounds/nature/175.jpg')">
        <div class="header-content">
          <div class="title container">
            <h1>功能介紹--重建家園</h1>
          </div>
        </div>
      </div>
      <div class="header-bottom">
        <div class="container">
          <div class="blog-info">
            2026年3月9日·功能介紹
          </div>
        </div>
      </div>
    </div>
    <div class="blog-body">
      <div class="container">
        <div class="blog-content font">
          <div class="block-item">
            <p style="font-size: 20px;">
              面對突如其來的重大災害,災後的重建之路總是艱辛且漫長。為了協助公益夥伴們能在第一時間精準、快速地募集到重建所需的物資,我們特別規劃了「重建家園」活動專區。
            </p>
          </div>
          <div class="block-item">
            <p style="font-size: 20px;">
              這是專門針對重大災害(如地震、颱風)所設計的高曝光、時效性且具聚焦性的管道。
            </p>
          </div>
          <div class="block-item center">
            <img class="img-item" src="../assets/post-7-1.png" alt="重建家園專區"/>
          </div>
          <div class="block-item">
            <h2 style="font-size: 28px; margin-top: 40px; margin-bottom: 20px;">為什麼要使用「重建家園」專區？</h2>
          </div>
          <div class="block-item">
            <p style="font-size: 20px;">重建專區具備以下功能,能讓社會大眾的愛心有效直達：</p>
            <p style="font-size: 20px;"><strong>專屬標籤：</strong>需求會標註「災害專區標籤」,大幅增加辨識度。</p>
            <p style="font-size: 20px;"><strong>流量集中：</strong>透過專頁彙整顯示,讓捐贈者能快速找到急需物資的單位。</p>
            <p style="font-size: 20px;"><strong>精準募集：</strong>協助單位在災後第一時間,精準地募集重建所需物資。</p>
          </div>
          <div class="block-item center">
            <img class="img-item" style="max-width: 300px;" src="../assets/post-7-2.png" alt="重建家園手機截圖"/>
          </div>
          <div class="block-item">
            <h2 style="font-size: 28px; margin-top: 40px; margin-bottom: 20px;">如何刊登與媒合？</h2>
          </div>
          <div class="block-item">
            <p style="font-size: 20px;">開通權限後,依照以下步驟快速刊登：</p>
            <p style="font-size: 20px;">1. 進入刊登頁：點選「<strong>刊登需求</strong>」。</p>
            <p style="font-size: 20px;">2. 勾選專屬欄位：在需求類型中勾選對應的「<strong>災害事件</strong>」(例如：某某地震、某某颱風)。</p>
            <p style="font-size: 20px;">媒合流程：與一般需求流程相同,「刊登需求 → 捐贈者登記贈送 → 社工確認 → 系統顯示收件資訊 → 單位收到物品,留言感謝」。</p>
          </div>
          <div class="block-item center">
            <img class="img-item" style="max-width: 300px;" src="../assets/post-7-3.png" alt="刊登需求截圖"/>
          </div>
          <div class="block-item center" style="margin-top: 60px;">
            <h4 style="font-size: 20px; color: #1f1f1f;">重建家園為愛引航,專屬標籤讓需求精準對接</h4>
          </div>
          <div class="block-item center">
            <h4 style="font-size: 20px; color: #1f1f1f;">讓每一份愛心,溫暖地抵達最需要的地方！</h4>
          </div>
          <div class="block-item">
            <div class="separator"></div>
          </div>
          <div class="block-item center">
            <p style="font-size: 18px; color: #444;">📣3分鐘深入身入了解--&gt; <a style="color: #f67d0c;" href="https://bit.ly/4bjeJjr" target="_blank"><u><strong>立即前往</strong></u></a></p>
          </div>
        </div>
      </div>
    </div>
    <div class="blog-footer">
      <div class="container">
        <div class="footer-nav">
          <div class="btn-previous footer-btn">
            <div>上一篇</div>
            <a v-if="prev" class="title" :href="prev.link">{{ prev.title }}</a>
          </div>
          <div class="btn-next footer-btn">
            <div>下一篇</div>
            <a v-if="next" class="title" :href="next.link">{{ next.title }}</a>
          </div>
        </div>
        <div class="footer-toolbar">
          <a target="_self" href="/" class="back-link">
            <span class="left-open-big"></span>
            &nbsp;返回網站
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    post: {
      type: Object,
      default: () => ({})
    },
    prev: {
      type: Object,
      default: null
    },
    next: {
      type: Object,
      default: null
    }
  }
}
</script>
<style lang="less">
.font {
  font-family: montserrat,'PingFang TC','Microsoft JhengHei','微軟正黑體',STXihei,sans-serif;
}

.center {
  text-align: center;
}

.blog-wrapper {
  .container {
    position: relative;
    max-width: 816px;
    margin: 0 auto;
    padding: 0;
    padding: 0 15px;

    @media screen and (min-width: 728px) and (max-width: 879px) {
      max-width: 640px;
    }
    @media screen and (min-width: 590px) and (max-width: 727px) {
      max-width: 556px;
    }
    @media screen and (min-width: 490px) and (max-width: 589px) {
      max-width: 456px;
    }
    @media screen and (min-width: 370px) and (max-width: 429px) {
      max-width: 336px;
    }
    @media screen and (max-width: 349px) {
      max-width: 296px;
    }
  }

  .header {
    .pad-cover {
      background-repeat: no-repeat;
      background-size: cover;
      background-color: transparent;
      background-position: 50% 50%;
      color: #fff;
      height: 340px;
      display: table;
      width: 100%;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
      }

      .header-content {
        padding: 40px 0 60px;
        display: table-cell;
        vertical-align: bottom;
      }

      .title {
        font-family: "istok web", helvetica, 'Lisong Pro', 'PMingLiU', 'PingFang TC','Microsoft JhengHei',"微軟正黑體",STXihei, sans-serif;
        text-shadow: 0 1px 12px rgb(0 0 0 / 35%);
      }
    }

    .header-bottom {
      .blog-info {
        padding: 12px 0;
        border-bottom: 1px solid #ddd;
        color: #a9aeb2;
        font-size: 14px;
      }
    }
  }
}

.blog-body {
  padding: 30px 0;
  .blog-content {
    color: #444;
    line-height: 1.7;
    word-wrap: break-word;
    font-size: 20px;
    font-weight: 400;
    font-style: normal;

    p {
      margin: 0;
      padding: 0;
      border: 0;
      margin-bottom: 15px;
    }

    h2, h4 {
      margin: 0;
      padding: 0;
    }

    .block-item {
      margin-bottom: 30px;
    }

    .img-item {
      max-width: 100%;
    }

    .separator {
      height: 2px;
      background: #ddd;
      width: 240px;
      margin: 0 auto;
      border-radius: 2px;
    }
  }
}
.blog-footer {
  padding-top: 30px;
  padding-bottom: 200px;
  background: #fff;
  color: #999;

  .footer-nav {
    padding: 22px 0;
    font-size: 14px;
    border-top: 1px solid #ddd;
    color: #999;
  }

  .btn-previous {
    padding-right: 10px;
    box-sizing: border-box;
    color: #a9aeb2;
  }
  .footer-btn {
    display: inline-block;
    zoom: 1;
    width: 50%;
    vertical-align: top;
  }

  .btn-next {
    padding-left: 10px;
    box-sizing: border-box;
    color: #a9aeb2;
  }

  .title {
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    color: #000;
    margin-top: 5px;
    line-height: 1.25;
    font-family: "istok web", helvetica, 'Lisong Pro', 'PMingLiU', 'PingFang TC','Microsoft JhengHei',"微軟正黑體",STXihei, sans-serif;
    cursor: pointer;
    text-decoration: none;
  }

  .footer-toolbar {
    font-size: 14px;
    padding-top: 15px;
    border-top: 1px solid #ddd;

    .back-link {
      display: inline-block;
      margin: 0 30px 10px 0;
      line-height: 20px;
      color: #a9aeb2;
      text-decoration: none;

      .left-open-big {
        &::before {
          content: "<";
          font-family: entypo;
          font-style: normal;
          font-weight: 400;
          display: inline-block;
          text-decoration: inherit;
          width: 1em;
          text-align: center;
          font-variant: normal;
          text-transform: none;
          line-height: 1em;
        }
      }
    }
  }
}
</style>
